import instanceAxios from '@/util/axios';
import { ExtractEventRequest, ExtractEventResponse } from './extractEvent.types';
import { aiExtractEventUrl } from '@/constants';

export async function extractEvent(body: ExtractEventRequest): Promise<ExtractEventResponse> {
  // The request stays open until the AI finishes reading the flyer.
  const response = await instanceAxios.post<ExtractEventResponse>(aiExtractEventUrl, body, { timeout: 60000 });
  return response.data;
}
